"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const area_types_1 = require("./area.types");
const area_1 = require("services/master-data/area");
const pit_1 = require("services/master-data/pit");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, area_1._getMasterArea)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: area_types_1.areaTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: area_types_1.areaTypes.SET_DATA_GRID, payload });
    }
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responsePit = yield (0, pit_1._getMasterPit)(dataStates);
    const dataPit = responsePit.data;
    dispatch({
        type: area_types_1.areaTypes.GET_DETAIL, payload: {
            dataPit,
        }
    });
});
const dataStates = {
    filterable: true,
    sortable: true,
    reorderable: false,
    scrollable: 'scrollable',
    skip: 0,
    take: 100,
    total: 0,
    filter: {
        'logic': 'and',
        'filters': [
            { 'field': 'is_active', 'operator': 'eq', 'value': true }
        ]
    },
};
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, area_1._getMasterArea)(dataStates);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
        }),
        dataStates
    };
    dispatch({ type: area_types_1.areaTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: area_types_1.areaTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode } = payload;
    const response = payload.mutationMode === 'add' ?
        yield (0, area_1._createArea)({
            area_code: payload.dataItem.area_code,
            area_name: payload.dataItem.area_name,
            is_active: payload.dataItem.is_active.value,
            id_pit: payload.dataItem.pit.id
        }) :
        yield (0, area_1._editArea)({
            id: payload.dataItem.id,
            area_code: payload.dataItem.area_code,
            area_name: payload.dataItem.area_name,
            is_active: payload.dataItem.is_active.value,
            id_pit: payload.dataItem.pit.id
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: area_types_1.areaTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    }
    else {
        dispatch({ type: area_types_1.areaTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, area_1._deleteArea)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: area_types_1.areaTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    }
    else {
        dispatch({ type: area_types_1.areaTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: area_types_1.areaTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: area_types_1.areaTypes.ON_SORT_CHANGE, payload });
};
const toggleError = payload => dispatch => {
    dispatch({ type: area_types_1.areaTypes.SET_ERROR, payload });
};
const onLoading = () => dispatch => {
    dispatch({ type: area_types_1.areaTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onDelete,
    onFilterChange,
    onSortChange,
    toggleError,
    onLoading,
    getDetail
};
